module.exports = __webpack_public_path__ + "media/icon_transaction/dog-55222bd1.png";